import {memo} from 'react'
import {useTranslation} from 'react-i18next'

export const RowHead = () => {
  const {t} = useTranslation()

  return (
    <tr>
      <th>{t('Findoc ID')}</th>
      <th>{t('Findoc Number')}</th>
      <th>{t('order-pembeli')}</th>
      <th>{t('SAP Number')}</th>
      <th>{t('kontrak-tanggal')}</th>
      <th>Sales Org</th>
      <th>{t('sub-order-sektor')}</th>
      <th>{t('Tanggal Findoc')}</th>
      <th>{t('Ext Findoc Number')}</th>
      <th>{t('Findoc Type')}</th>
      <th>{t('Skbdn Type')}</th>
      <th>{t('no skkp/lecto')}</th>
      <th>{t('sub-order-negara')}</th>
      <th>{t('mataUang')}</th>
      <th>Bank</th>
      <th>{t('Findoc Value')}</th>
      <th>{t('uangSaku')}(%)</th>
      <th>{t('sisafindoc')}</th>
      <th>TOP</th>
      <th>Incoterm</th>
      <th>{t('Valid Start Date')}</th>
      <th>{t('valid End Date')}</th>
      <th>{t('Latest Shipment Date')}</th>
      <th>Status</th>
      <th>{t('kontrak-aksi')}</th>
      {/* <th >{t('Findoc_Name')}</th> */}
    </tr>
  )
}

export default memo(RowHead)
